export default function Go_Exercises () {
  return (
    <div>
      <h1>Go_Exercises </h1>
      <p>Go Exercises</p>
    </div>
  );
}